import { uploadComponentCtrl } from '../uploadComponent';
import uploadAreaView from './uploadAreaComponent.html';
import './uploadAreaComponent.css';
import { zIndexManager } from 'components/sharpr/zIndex/manager/zIndexManager';

export function uploadAreaComponent() {
	return {
		bindings: {
			files: '=?',
			state: '=?',
			percent: '=?',
			dragText: '@',
			onAdd: '&?',
			onStart: '&?',
			onProgress: '&?',
			onEnd: '&?',
			onError: '&?',
			createAttachment: '<?',
			positionFixed: '<',
			allowDuplicates: '<?',
			spaceOutMs: '<?',
		},
		controllerAs: 'vm',
		controller: uploadAreaComponentCtrl,
		template: uploadAreaView,
	};
}

export class uploadAreaComponentCtrl extends uploadComponentCtrl {
	getOptions() {
		const options = super.getOptions();
		let triggerZone = this.positionFixed ? document.querySelector('main') : this.$element[0].parentNode;
		if (triggerZone) {
			options.drop_element = triggerZone;
			this.$dropZone = angular.element(triggerZone);
		}
		return options;
	}

	$onInit() {
		this.files = [];
		this.inProgress = [];
		this.multiSelection = true;
		if (this.positionFixed) {
			this.$element.css('position', 'fixed');
		} else if (this.$dropZone && this.$dropZone.css('position') === '') {
			this.$dropZone.css('position', 'relative');
		}
		super.$onInit();
	}

	setupPluploader() {
		super.setupPluploader();
		this.pluploader.bind('Drop', this._handleDrop.bind(this));
		this.pluploader.bind('DragEnter', this._handleDragEnter.bind(this));
		this.pluploader.bind('DragLeave', this._handleDragLeave.bind(this));
	}

	/**
	 * Pull in files and directories that were dropped
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
	 * @see https://www.html5rocks.com/en/tutorials/file/filesystem/
	 * @param evt  The drop event
	 * @private
	 */
	_handleDrop(evt) {
		this.$element.css('display', 'none');
		this.pluploader.start();
	}

	_handleDragEnter() {
		if (this.$element.css('display') != 'flex') {
			this.$element.css('display', 'flex');
			zIndexManager.bringToTop(this.$element);
		}
	}

	_handleDragLeave() {
		this.$element.css('display', 'none');
	}

	_handleFilesAdded($plupload, $files) {
		super._handleFilesAdded($plupload, $files);
		$files.forEach($file => {
			this.EventTracker.save('drag_file', {
				filename: $file.name,
			});
			this.onAdd && this.onAdd({ $plupload, $file });
		});
		this.$timeout(() => {});
	}

	_handleBeforeUpload($plupload, $file) {
		super._handleBeforeUpload($plupload, $file);
		if (this.onStart) {
			this.onStart({ $plupload, $file });
			this.$timeout(() => {});
		}
	}

	_handleUploadProgress($plupload, $file) {
		super._handleUploadProgress($plupload, $file);
		if (this.onProgress) {
			this.onProgress({ $plupload, $file });
			this.$timeout(() => {});
		}
	}

	_handleFileUploaded($plupload, $file) {
		this._createAttachment($file).then(() => {
			if (this.onEnd) {
				this.onEnd({ $plupload, $file });
				this.$timeout(() => {});
			}
		});
	}
}
